import {Input,Button, Container, Heading, VStack } from '@chakra-ui/react'
import React, { useState } from 'react'

const ChangePassword = () => {
    const [oldPassword,setOldPassword]=useState();
    const [newPassword,setNewPassword]=useState();
  return (
    <Container py='16' minH={'90vh'}>
        <form>
            <Heading children='Change password' my='16' textAlign={['center']} />
            <VStack spacing={'8'}>
                <Input required value={oldPassword} onChange={(e)=>setOldPassword(e.target.value)} placeholder='Enter old password' type='password' focusBorderColor='yellow.500' />
                <Input required value={newPassword} onChange={(e)=>setNewPassword(e.target.value)} placeholder='Enter new password' type='password' focusBorderColor='yellow.500' />
                <Button w='full' colorScheme='yellow' type='submit'>
                    Change
                </Button>
            </VStack>
        </form>
    </Container>
  )
}

export default ChangePassword